import React from "react";
import { useTranslation } from "react-i18next";
import { FiCode, FiSearch, FiMessageCircle } from "react-icons/fi";
import "./style.min.css";

const WorkMethod = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const methods = [
    {
      icon: <FiCode size={26} />,
      title: t("work.fullstack.title"),
      desc: t("work.fullstack.desc"),
    },
    {
      icon: <FiSearch size={26} />,
      title: t("work.seo.title"),
      desc: t("work.seo.desc"),
    },
    {
      icon: <FiMessageCircle size={26} />,
      title: t("work.communication.title"),
      desc: t("work.communication.desc"),
    },
  ];

  return (
    <section
      id="work"
      dir={lang === "ar" ? "rtl" : "ltr"}
      className="work-section"
      style={{
        background: "var(--body_background)",
        color: "var(--color_text)",
      }}
    >
      {/* Title */}
      <div className="work-header">
        <h2 className="title-gradient work-title">
          {t("work.title")}
        </h2>
      </div>

      {/* Cards */}
      <div className="work-grid">
        {methods.map((item, index) => (
          <div key={index} className="work-card glass-card">
            <div className="work-icon">{item.icon}</div>
            <h3 className="work-card-title">{item.title}</h3>
            <p className="work-card-desc">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WorkMethod;
